module.exports = __webpack_public_path__ + "static/img/solar_s.9d2e4dc3.svg";